export default __webpack_public_path__ + "static/media/list.3d8b4f64.svg";